import React from "react";

const c = {
  heading: "#6D28D9",
  text: "#374151",
};

const CommitmentAndCTA = () => {
  return (
    <div className="w-full px-4 sm:px-8 lg:px-20 bg-white flex flex-col gap-6 font-['Poppins',sans-serif]">
      
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&family=Caveat:wght@600&display=swap');
      `}</style>

      {/* ---------- Card 1: Our Commitment ---------- */}
      <div className="relative w-full rounded-[28px] sm:rounded-[36px] overflow-hidden min-h-[540px] sm:min-h-full lg:min-h-full">
        {/* Mobile background */}
        <div
          className="sm:hidden absolute inset-0 bg-cover bg-bottom bg-no-repeat"
          style={{ backgroundImage: "url('/img/community-guidelines/phoneOurCommitment.svg')" }}
        />
        {/* Desktop background */}
        <div
          className="hidden sm:block absolute inset-0 bg-cover bg-right bg-no-repeat"
          style={{ backgroundImage: "url('/img/community-guidelines/OurCommitment.png')" }}
        />

        <div className="relative z-10 flex flex-col justify-start sm:justify-center items-center sm:items-start text-center sm:text-left p-8 sm:pb-10  sm:max-w-[55%]">
          <h2
            style={{ color: c.heading }}
            className="text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight mb-5 sm:mb-6"
          >
            Our Commitment
          </h2>

          <p
            style={{ color: c.text }}
            className="text-[11px] sm:text-[13px] lg:text-[15px] leading-relaxed mb-3 sm:mb-4 max-w-lg font-medium"
          >
            We believe travel creates friendships, broadens perspectives, and
            brings people together.
          </p>

          <p
            style={{ color: c.text }}
            className="text-[11px] sm:text-[13px] lg:text-[15px] leading-relaxed mb-6 sm:mb-8 max-w-lg font-medium"
          >
            Every SoloConnect member contributes to making our community safer,
            more respectful, and more welcoming.
          </p>

          <p
            style={{ color: c.heading }}
            className="font-['Caveat',cursive] text-2xl sm:text-3xl lg:text-[4xl] font-semibold tracking-wide"
          >
            Thank you for being part of SoloConnect.
          </p>
        </div>
      </div>

      {/* ---------- Card 2: Travel Better CTA ---------- */}
      <div className="relative w-full rounded-[28px] sm:rounded-[36px] overflow-hidden min-h-[500px] sm:min-h-[220px] bg-[#E5D6FC] mb-10">
        {/* Mobile background */}
        <div
          className="sm:hidden absolute inset-0 bg-cover bg-bottom bg-no-repeat"
          style={{ backgroundImage: "url('/img/community-guidelines/BagpackImage.png')" }}
        />
        {/* Desktop background */}
        <div
          className="hidden sm:block absolute inset-0 bg-cover bg-left bg-no-repeat"
          style={{ backgroundImage: "url('/img/community-guidelines/TravelBetter.png')" }}
        />

        <div className="relative z-10 flex flex-col justify-start sm:justify-center items-center sm:items-start text-center sm:text-left p-6 pt-10 md:pt-14 sm:pb-8 sm:p-8 md:pl-[30%] lg:pl-[32%]">
          <h3
            style={{ color: c.heading }}
            className="text-xl sm:text-2xl lg:text-3xl font-extrabold mb-3"
          >
            Travel Better. Connect Smarter. Explore Together.
          </h3>
          <p
            style={{ color: c.text }}
            className="text-[14px] sm:text-base leading-relaxed max-w-md font-medium"
          >
            Let's create unforgettable memories while keeping our community safe
            and positive for everyone.
          </p>
        </div>
      </div>


    </div>
  );
};

export default CommitmentAndCTA;
